//React
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
//Fetch
import axios from "axios"
//Context
import { useAuthContext } from "../../../Hooks/useAuthContext"
//Icons
import { faAdd, faArrowLeft } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
//Notifications
import { toast } from "react-toastify"
//Components
import MainContainer from "../../../Components/Containers/MainContainer"
import Loading from "../../../Components/Loading/Loading"
import FloatingDistrictSelect from "../../../Components/SelectDropdowns/FloatingDistrictSelect"
import FloatingUnitarySelect from "../../../Components/SelectDropdowns/FloatingUnitarySelect"
import FloatingLocalitySelect from "../../../Components/SelectDropdowns/FloatingLocalitySelect"
import FormControl from "../../../Components/Forms/FormControl"

export default function ParishDistricts() {
    const navigate = useNavigate()
    const { user, dispatch } = useAuthContext()

    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)
    const [showForm, setShowForm] = useState(false)
    const [searchTerm, setSearchTerm] = useState("")

    const [parishes, setParishes] = useState([])

    const [newRecord, setNewRecord] = useState({
        parish: "",
        district: "",
        locality: "",
        unitaryAuthority: ""
    });



    useEffect(() => {
        const listParishes = async () => {
            if (searchTerm === "") {
                setParishes([]);
            }
            else {

                try {
                    const res = await axios.get(
                        `https://${process.env.REACT_APP_IP}/api/parishdistricts?search=${searchTerm}`,
                        {
                            headers: { Authorization: `bearer ${user.token}` },
                        }
                    );

                    setParishes(res.data.results);
                } catch (error) {
                    if (error.response.status === 401) {
                        dispatch({ type: "LOGOUT" });
                        navigate("../../expired");
                    } else {
                        setError(error.response.status);
                    }
                } finally {
                    setLoading(false);
                }
            }

            setLoading(false);
        };

        listParishes();
        
    }, [dispatch, user, navigate, searchTerm]);


    const handleLocalChange = async (id, field, value) => {
        setParishes(prev =>
            prev.map(i =>
                i.id === id ? { ...i, [field]: value } : i
            )
        );
    };

    const handleBlur = async (id) => {
        const updatedRecord = parishes.find(i => i.id === id);

        try {
            await axios.put(`https://${process.env.REACT_APP_IP}/api/parishdistricts/${id}`, updatedRecord, {
                headers: { Authorization: `bearer ${user.token}` },
            });
        } catch (err) {
            console.error("Update failed", err);
        }
    };

    const handleNewChange = (field, value) => {
        setNewRecord(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleAddNew = async () => {
        try {
            const response = await axios.post(`https://${process.env.REACT_APP_IP}/api/parishdistricts`, newRecord, {
                headers: { Authorization: `bearer ${user.token}` },
            });

            // Add new record locally (API should return the created record with an ID)
            setParishes(prev => [...prev, response.data]);

            // Reset the form
            setNewRecord({
                parish: "",
                district: "",
                locality: "",
                unitaryAuthority: ""
            });
        } catch (err) {
            console.error("Create failed", err);
        }
    };
    


  if (!loading) {
    return error ? (
      <MainContainer>Some error...</MainContainer>
    ) : (
            <MainContainer>
                {/* Back Button */}
                <div className="d-flex justify-content-end mb-2">
                    <button
                        className="btn btn-primary my-2 "
                        onClick={() => navigate(-1)}
                    >
                        Back <FontAwesomeIcon icon={faArrowLeft} />
                    </button>
                </div>

                <div className=" primaryShadow p-3">
                    <div className="d-flex justify-content-between">
                        <h3 className=" mb-3">Parish / Districts</h3>
                    </div>
                    <div className="col ">
                        { /* Search */}
                        <div className="d-flex flex-column flex-md-row  ">
                            <div className="form-floating col-12">
                                <input
                                    placeholder="Search"
                                    className="form-control"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                <label>
                                    Search
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                {parishes.length > 0 && (

                        <div className=" primaryShadow p-3 mt-3">
                    
                            <h4 className=" mb-3">Search Results</h4>
                            <hr />
                            <div className="col">

                                {parishes.map((entry) => (
                                    <div key={entry.id} className="row mb-2">
                                        <div className="col-md-3">
                                            <input
                                                placeholder="Parish"
                                                className="form-control"
                                                value={entry.parish}
                                                onChange={(e) =>
                                                    handleLocalChange(entry.id, "parish", e.target.value)
                                                }
                                                onBlur={() => handleBlur(entry.id)}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <input
                                                placeholder="District"
                                                className="form-control"
                                                value={entry.district}
                                                onChange={(e) =>
                                                    handleLocalChange(entry.id, "district", e.target.value)
                                                }
                                                onBlur={() => handleBlur(entry.id)}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <input
                                                placeholder="Locality"
                                                className="form-control"
                                                value={entry.locality}
                                                onChange={(e) =>
                                                    handleLocalChange(entry.id, "locality", e.target.value)
                                                }
                                                onBlur={() => handleBlur(entry.id)}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <input
                                                placeholder="Unitary Authority"
                                                className="form-control"
                                                value={entry.unitaryAuthority}
                                                onChange={(e) =>
                                                    handleLocalChange(entry.id, "unitaryAuthority", e.target.value)
                                                }
                                                onBlur={() => handleBlur(entry.id)}
                                            />
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>

                )}

                <div className=" primaryShadow p-3 mt-3">

                    <h4 className=" mb-3">Create</h4>
                    <hr />
                    <div className="row mb-2">

                        {/* Parish */}
                        <FormControl
                            value={newRecord.parish}
                            label={"Parish"}
                            field={"parish"}
                            setField={handleNewChange}
                            classes={"col-md-3"}
                        />

                        {/* District */}
                        <FloatingDistrictSelect
                            value={newRecord.district}
                            field={"district"}
                            setField={handleNewChange}
                            classes={"col-md-3"}
                        />

                        {/* Locality */}
                        <FloatingLocalitySelect
                            value={newRecord.locality}
                            field={"locality"}
                            setField={handleNewChange}
                            classes={"col-md-3"}
                        />

                        {/* Unitary Authority */}
                        <FloatingUnitarySelect
                            value={newRecord.unitaryAuthority}
                            field={"unitaryAuthority"}
                            setField={handleNewChange}
                            classes={"col-md-3"}
                        />
                        
                    </div>

                    <div className="col-12 mt-3">
                        <button
                            onClick={handleAddNew}
                            className="btn btn-primary w-100"
                        >
                            Add New Parish
                        </button>
                    </div>
                </div>
        </MainContainer>
    )
  } else {
    return (
      <MainContainer>
        <Loading />
      </MainContainer>
    )
  }
}
